import axios from 'axios';
import createPersistentStorage from "./persistent-storage";
import {react_app_backend_url} from "./globalApi";
import {BuoyDeployment, BuoyDeploymentRelation, DeploymentDataEntry, Job, UserDto} from "./dtos/dtos";

const accessTokenStorage = createPersistentStorage<string>("access_token");

// const orgCreate = axios.create;
// axios.create = function (config?: AxiosRequestConfig): AxiosInstance {
//     const result = orgCreate.call(this, config);
//     (axios.interceptors.request as any).handlers.forEach((handler: any) => {
//         result.interceptors.request.use(handler.fulfilled, handler.rejected);
//     });
//     (axios.interceptors.response as any).handlers.forEach((handler: any) => {
//         result.interceptors.response.use(handler.fulfilled, handler.rejected);
//     });
//
//     return result;
// }

const axiosInstance = axios.create();

axiosInstance.interceptors.request.use(function (config) {
    if (config?.headers) {
        const token = accessTokenStorage.read();
        if (token !== undefined) {
            config.headers.Authorization = 'Bearer ' + accessTokenStorage.read();
        }
    }

    return config;
});

axiosInstance.interceptors.response.use(
    response => {
        return response
    },
    error => {
        if (error.response?.status === 401) {
            console.error("Authorization error: " + error.response.status)
            window.location.href = "/login";
        }

        return Promise.reject(error.response ? {
            status: error.response.status,
            statusText: error.response.statusText,
            message: error.response.data?.detail
        } : {
            status: "unkown",
            message: error.message
        })
    });

const backendUrl = react_app_backend_url + "";

export const recursiveToCamel = (item: unknown): unknown => {
    if (Array.isArray(item)) {
        return item.map((el: unknown) => recursiveToCamel(el));
    } else if (typeof item === 'function' || item !== Object(item)) {
        return item;
    }
    return Object.fromEntries(
        Object.entries(item as Record<string, unknown>).map(
            ([key, value]: [string, unknown]) => [
                key.replace(/([-_][a-z])/gi, c => c.toUpperCase().replace(/[-_]/g, '')),
                recursiveToCamel(value),
            ],
        ),
    );
};

export function getJobs() : Promise<{ status: number, data: Job[] }> {
    const client = axiosInstance;
    return client.get(`${backendUrl}/jobs`);
}

export function getJob(jobId: string) : Promise<{ status: number, data: Job }> {
    const client = axiosInstance;
    return client.get(`${backendUrl}/jobs/${jobId}`);
}

export const getDeploymentDataEntries = (jobId: string, from?: Date, to?: Date) : Promise<{ status: number, data: DeploymentDataEntry[] }> =>
    axiosInstance.get(`${backendUrl}/jobs/${jobId}/data-entries?from=${from?.toISOString()}&to=${to?.toISOString()}`);

export const discardDeploymentDataEntries = (jobId: string, dataEntryIds: string[]) : Promise<{ status: number }> =>
    axiosInstance.post(`${backendUrl}/jobs/${jobId}/data-entries/discard`, dataEntryIds);

export const keepDeploymentDataEntries = (jobId: string, dataEntryIds: string[]) : Promise<{ status: number }> =>
    axiosInstance.post(`${backendUrl}/jobs/${jobId}/data-entries/keep`, dataEntryIds);

export const syncDeploymentDataEntries = (jobId: string, dataEntryIds: string[]) : Promise<{ status: number }> =>
    axiosInstance.post(`${backendUrl}/jobs/${jobId}/data-entries/sync`, dataEntryIds);
// export function getDeployment(deploymentId: string) : Promise<{ status: number, data: Deployment }> {
//     const client = axiosInstance;
//     return client.get(backendUrl + "deployments/" + deploymentId);
// }

// export const getDeploymentDataEntries = (deploymentId: string, from?: Date, to?: Date) : Promise<{ status: number, data: DeploymentDataEntry[] }> =>
//      axiosInstance.get(`${backendUrl}/deployments/${deploymentId}/data-entries?from=${from?.toISOString()}&to=${to?.toISOString()}`);

// export const deleteDeploymentDataEntries = (deploymentId: string, dataEntryIds: string[]) : Promise<{ status: number }> =>
//     axiosInstance.post(`${backendUrl}/deployments/${deploymentId}/data-entries/delete`, dataEntryIds);

export const getCurrentUser = () : Promise<{ status: number, data: UserDto }> =>
    axiosInstance.get(`${backendUrl}/users/current`);

export const getBuoysRelations = () : Promise<{ status: number, data: BuoyDeployment[] }> =>
    axiosInstance.get(`${backendUrl}/buoys/deployment-relations`);

export const upsertBuoysRelations = (rel: BuoyDeploymentRelation) : Promise<{ status: number, data: BuoyDeployment[] }> =>
    axiosInstance.post(`${backendUrl}/buoys/deployment-relations`, rel);

export const deleteBuoysRelations = (rel: BuoyDeploymentRelation) : Promise<{ status: number, data: BuoyDeployment[] }> =>
    axiosInstance.post(`${backendUrl}/buoys/deployment-relations/delete`, rel);

export const upsertJobDataforwardingEnabled = (jobId: string, enabled: boolean) : Promise<{ status: number, data: number }> =>
    axiosInstance.put(`${backendUrl}/jobs/${jobId}/enable-data-forwarding`, { value: enabled});
